var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUser = function SvgUser(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.663 13.322a7.65 7.65 0 0 0 2.5-5.658C20.164 3.438 16.727 0 12.5 0S4.836 3.438 4.836 7.664c0 2.239.965 4.256 2.5 5.659C3.069 14.83 0 18.905 0 23.684a1.316 1.316 0 1 0 2.632 0c0-4.608 3.748-8.356 8.356-8.356h3.024c4.608 0 8.357 3.748 8.357 8.356a1.316 1.316 0 1 0 2.631 0c0-4.779-3.068-8.853-7.337-10.362M12.5 2.632a5.04 5.04 0 0 1 5.032 5.032 5.04 5.04 0 0 1-5.032 5.032 5.04 5.04 0 0 1-5.032-5.032A5.04 5.04 0 0 1 12.5 2.632"
  })));
};
export default SvgUser;